<div class="main-wrapper">
    <div class="inner-wrapper">
        <header>
            <button
                (click)="onBack()"
                class="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 hover:bg-accent rounded-md px-3 gap-2 text-muted-foreground hover:text-foreground mb-4"><svg
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-arrow-left h-4 w-4">
                    <path d="m12 19-7-7 7-7"></path>
                    <path d="M19 12H5"></path>
                </svg>{{'profile.back' | translate}}</button>
            <h1 class="sr-only">Företag</h1>
        </header>
        <div class="user-head">
            <h1>{{'profile.title' | translate}}</h1>
            <button *ngIf="customer?.employeeRole?.id != 3" (click)="onOpenCreateCompanyModal()"
                aria-label="Create New Company">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class=" w-4 h-4" data-lov-id="src/components/EventCompany.tsx:175:12" data-lov-name="PlusIcon"
                    data-component-path="src/components/EventCompany.tsx" data-component-line="175"
                    data-component-file="EventCompany.tsx" data-component-name="PlusIcon"
                    data-component-content="%7B%22class%22%3A%22w-4%20h-4%20mr-2%22%7D">
                    <path d="M5 12h14"></path>
                    <path d="M12 5v14"></path>
                </svg>
                <span>{{'profile.create-new-company' | translate}}</span>
            </button>
        </div>
        <!-- user information section -->
        <div class="user-body">
            <div class="user-info">
                <div class="user-info-head">
                    <h2><span>{{'profile.user-information' | translate}}</span></h2>
                </div>
                <div class="user-box">
                    <div class="user-uploaded">
                        <div class="user-uploaded-img">
                            <span>
                                <img [src]="previewUrl ?? employee?.avatar ?? '../../../assets/img/profile_user.webp'"
                                    alt="profile" loading="lazy">
                            </span>

                            <!-- Save button: shown after cropping -->
                            <i *ngIf="previewUrl" (click)="onSaveAvatar()" style="cursor:pointer"
                                [matTooltip]="'Save' | translate" matTooltipPosition="below">
                                <mat-icon>save</mat-icon>
                            </i>

                            <i *ngIf="!previewUrl" [matTooltip]="'profile.change-logo' | translate"
                                matTooltipPosition="below">
                                <label style="cursor:pointer;margin-bottom: 2px;">
                                    <input type="file" accept="image/*" (change)="onChangeAvatar($event)" hidden>
                                    <img src="../../../assets/svg/camera.svg" alt="camera">
                                </label>
                            </i>
                        </div>

                        <div class="user-name">
                            <!-- Single role display above the name -->
                            <span *ngIf="customer?.employeeRole?.name" [ngClass]="{
                            'purple-pill': customer?.employeeRole?.name === 'Super Admin',
                            'green-pill': customer?.employeeRole?.name === 'Owner',
                            'blue-pill': customer?.employeeRole?.name === 'Administrator',
                            'orange-pill': customer?.employeeRole?.name !== 'Super Admin' 
                                            && customer?.employeeRole?.name !== 'Administrator' 
                                            && customer?.employeeRole?.name !== 'Owner'
                        }">
                                {{ customer?.employeeRole?.name }}
                            </span>

                            <!-- Employee name below the role -->
                            <h4 *ngIf="employee?.firstName; else noContent" class="value">{{ employee?.firstName }}</h4>
                            <ng-template #noContent>
                                <h4 class="value">{{ 'profile.unset' | translate }}</h4>
                            </ng-template>
                        </div>


                    </div>
                    <div class="user-info-item">
                        <div class="user-info-item-label">
                            <h3>
                                <i>
                                    <img src="../../../assets/svg/user.svg" alt="User" loading="lazy">
                                </i>
                                <span>{{ 'profile.name' | translate }}</span>

                                <button *ngIf="!isEditingFirstName" (click)="onEditFirstName()"
                                    [matTooltip]="'edit' | translate"
                                    class="p-[6px] rounded-lg text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                                    <svg class="lucide lucide-pen" fill="none" height="14" stroke="currentColor"
                                        stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                        </path>
                                    </svg>
                                </button>

                                <button *ngIf="isEditingFirstName" type="submit" (click)="onSaveFirstName()"
                                    mat-icon-button color="primary" [matTooltip]="'save' | translate" aria-label="Save">

                                    <mat-icon>save</mat-icon>
                                </button>

                            </h3>
                            <ng-container *ngIf="!isEditingFirstName; else editFirstName">
                                <ng-container *ngIf="employee?.firstName; else noFirstName">
                                    <label>{{ employee.firstName }}</label>
                                </ng-container>
                            </ng-container>

                            <ng-template #noFirstName>
                                <label class="text-muted">{{'profile.unset' | translate}}</label>
                            </ng-template>

                            <ng-template #editFirstName>
                                <input *ngIf="isEditingFirstName" type="text" [(ngModel)]="editedFirstName"
                                    maxlength="50" class="form-control"
                                    placeholder="{{ 'profile.name' | translate }}" />
                            </ng-template>
                        </div>

                        <!-- email -->
                        <div class="user-info-item-label">
                            <h3>
                                <i><img src="../../../assets/svg/email.svg" alt="Email" loading="lazy"></i>
                                <span>{{'profile.email' | translate}}</span>
                            </h3>
                            <label *ngIf="employee?.email; else noContent">{{employee?.email}}</label>
                            <ng-template #noContent>
                                <label class="value">{{'profile.unset' | translate}}</label>
                            </ng-template>
                        </div>

                        <div class="user-info-item-label">
                            <h3>
                                <i>
                                    <img src="../../../assets/svg/phone-2.svg" alt="Phone" loading="lazy">
                                </i>
                                <span>{{ 'profile.phone' | translate }}</span>

                                <button *ngIf="!isEditingPhone" (click)="onEditPhone()"
                                    [matTooltip]="'edit' | translate"
                                    class="p-[6px] rounded-lg text-muted-foreground hover:text-foreground hover:bg-accent transition-colors">
                                    <svg class="lucide lucide-pen" fill="none" height="14" stroke="currentColor"
                                        stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        viewBox="0 0 24 24" width="14" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                        </path>
                                    </svg>
                                </button>
                                <!-- Save button -->
                                <button *ngIf="isEditingPhone" type="submit" (click)="onSavePhone()" mat-icon-button
                                    color="primary" [matTooltip]="'save' | translate" aria-label="Save">
                                    <mat-icon>save</mat-icon>
                                </button>
                            </h3>

                            <ng-container *ngIf="!isEditingPhone; else editPhone">
                                <ng-container *ngIf="employee?.phone; else noPhone">
                                    <label>{{ employee.phone }}</label>
                                </ng-container>
                            </ng-container>

                            <ng-template #noPhone>
                                <label class="text-muted">{{'profile.unset' | translate}}</label>
                            </ng-template>
                            <!-- Input when editing -->
                            <ng-template #editPhone>
                                <input *ngIf="isEditingPhone" type="tel" [(ngModel)]="editedPhone" class="form-control"
                                    placeholder="{{ 'profile.phone' | translate }}" inputmode="numeric" pattern="[0-9]*"
                                    (keypress)="onPhoneKeyPress($event)" (input)="onPhoneInput($event)" />
                            </ng-template>
                        </div>

                        <div class="user-info-item-label">
                            <h3><span>{{'profile.language-settings' | translate}}</span></h3>
                            <div class="user-info-item-label-select">
                                <select (change)="onChangeApplicationLanguage($event.target.value)"
                                    aria-label="Select language">
                                    <option value="en" [selected]="employee?.locale == 'en'">{{'profile.en' |
                                        translate}}</option>
                                    <option value="sv" [selected]="employee?.locale == 'sv'">{{'profile.sv' |
                                        translate}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="user-key relative flex items-center justify-center ml-[12px] bg-white"
                            *ngIf="!isSsoUser">
                            <button class="user-key-btn" (click)="onOpenPasswordModal()" aria-label="Change Password">
                                <i>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.6504 4.93149L12.2944 6.57554C12.4281 6.70651 12.6077 6.77987 12.7948 6.77987C12.9819 6.77987 13.1615 6.70651 13.2952 6.57554L14.7962 5.07445C14.9272 4.94084 15.0006 4.76119 15.0006 4.57409C15.0006 4.38699 14.9272 4.20735 14.7962 4.07373L13.1522 2.42969"
                                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M14.5808 1L7.71875 7.86209" stroke="currentColor"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M4.93141 14.5811C7.10266 14.5811 8.86282 12.8209 8.86282 10.6497C8.86282 8.47841 7.10266 6.71826 4.93141 6.71826C2.76015 6.71826 1 8.47841 1 10.6497C1 12.8209 2.76015 14.5811 4.93141 14.5811Z"
                                            stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </i>
                                <span>{{'profile.change-password' | translate}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- company details section -->
            <div class="user-info">
                <div class="user-info-head">
                    <h2>
                        <span>{{'profile.company-details' | translate}}</span>
                    </h2>
                </div>
                <div class="user-box">
                    <div class="user-info-item">
                        <div class="user-info-item-label">
                            <h3><span>{{'profile.company-name' | translate}}</span></h3>
                            <label *ngIf="customer?.companyName; else noContent">
                                <div
                                    class="relative w-[40px] h-[40px] flex items-center justify-center mr-[12px] bg-white">
                                    @if(previewCompanyLogoUrl !== null) {
                                    <img class="!w-[30px] !h-[27px]" [src]="previewCompanyLogoUrl" alt="company-logo" />
                                    } @else if(customer?.image) {
                                    <img class="!w-[30px] !h-[27px]" [src]="customer?.image"
                                        (error)="onImageError($event)" alt="customer?.companyName" loading="lazy">
                                    } @else {
                                    <img class="!w-[30px] !h-[27px]" loading="lazy"
                                        src="../../../assets/img/safetly_logo_re.png" alt="company-logo" />
                                    }
                                    <button (click)="onChangeLogo()" aria-label="Change Logo"
                                        [matTooltip]="'profile.change-logo' | translate" matTooltipPosition="below"
                                        class="absolute -bottom-[4px] -right-[4px] bg-[#2563eb] hover:bg-[#1d4ed8] text-white p-[4px] shadow-lg transition-colors">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                                            strokeLinecap="round" strokeLinejoin="round" class="w-[12px] h-[12px]">
                                            <path
                                                d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z">
                                            </path>
                                            <circle cx="12" cy="13" r="3"></circle>
                                        </svg>
                                    </button>
                                </div>
                                <strong>{{customer?.companyName | titlecase}}</strong>
                            </label>
                            <ng-template #noContent>
                                <label class="value">{{'profile.unset' | translate}}
                                    <mat-icon class="w-[24px] h-[24px]">business</mat-icon>
                                </label>
                            </ng-template>
                        </div>
                        <div class="user-info-item-label">
                            <h3><span>{{'profile.organization_number' | translate}}</span></h3>
                            <label *ngIf="customer?.idNumber; else noContent">{{customer?.idNumber}}</label>
                            <ng-template #noContent>
                                <label class="value">{{'profile.unset' | translate}}</label>
                            </ng-template>
                        </div>
                        <div class="user-info-item-label">
                            <h3><span>{{'profile.address' | translate}}</span></h3>
                            <label *ngIf="customer?.address; else noContent">{{customer?.address}} {{customer?.city}}
                                {{customer?.country}}</label>
                            <ng-template #noContent>
                                <label class="value">{{'profile.unset' | translate}}</label>
                            </ng-template>
                        </div>
                        <div class="user-info-item-label">
                            <h3><span>{{'profile.contact-email' | translate}}</span></h3>
                            <label *ngIf="customer?.email; else noContent">{{customer?.email}}</label>
                            <ng-template #noContent>
                                <label class="value">{{'profile.unset' | translate}}</label>
                            </ng-template>
                        </div>
                        <div class="user-info-item-label">
                            <h3><span>{{'profile.phone' | translate}}</span></h3>
                            <label *ngIf="customer?.phone; else noContent">{{customer?.phone}}</label>
                            <ng-template #noContent>
                                <label class="value">{{'profile.unset' | translate}}</label>
                            </ng-template>
                        </div>
                        <div class="user-info-item-label">
                            <h3><span>{{'onboarding.company-form.company-details-form.website' | translate}}</span></h3>
                            <label
                                *ngIf="customer?.customerWebsite; else noContent">{{customer?.customerWebsite}}</label>
                            <ng-template #noContent>
                                <label class="value">{{'profile.unset' | translate}}</label>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
            <!-- employees section -->
            <div class="user-info" *ngIf="customer?.employeeRole?.id != 3">
                <div class="user-info-head">
                    <h2>
                        <i><img src="../../../assets/svg/users.svg" alt="Users" loading="lazy"></i>
                        <span>{{'profile.employee-with-access-title' |
                            translate}}</span>
                    </h2>
                    <button>{{this?.users?.length}} {{'profile.members' | translate}}</button>
                </div>
                <div class="user-box">
                    <div class="user-info-item members-wrapper">
                        <div class="members-box" *ngFor="let user of paginatedUsers">
                            <div class="members-picture">
                                <span><img
                                        [src]="user?.avatar != null ? user?.avatar : '../../../assets/img/profile_user.webp'"
                                        alt="profile"></span>
                                <i *ngIf="user?.employeeRole != null && user?.employeeRole?.id != 3"><img
                                        src="../../../assets/svg/crow.svg" alt="crow" /></i>
                            </div>
                            <div class="members-info">
                                <h3>
                                    <strong *ngIf="user?.firstName; else noName">{{user?.firstName}}</strong>
                                    <ng-template #noName>
                                        <strong>-</strong>
                                    </ng-template>
                                    <span [ngClass]="{
                                    'purple-pill': user?.employeeRole?.name === 'Super Admin',
                                    'green-pill': user?.employeeRole?.name === 'Owner',
                                    'blue-pill': user?.employeeRole?.name === 'Administrator',
                                    'orange-pill':
                                    user?.employeeRole?.name !== 'Super Admin' &&
                                    user?.employeeRole?.name !== 'Administrator' &&
                                    user?.employeeRole?.name !== 'Owner'
                                }">
                                        {{ user?.employeeRole?.name }}
                                    </span>
                                </h3>
                                <h6>
                                    <i><img src="../../../assets/svg/email.svg" alt="email" loading="lazy" /></i>
                                    <span>{{user?.email}}</span>
                                </h6>
                                <h6>
                                    <i><img src="../../../assets/svg/phone-2.svg" alt="phone" loading="lazy" /></i>
                                    <span *ngIf="user?.phone; else noPhone">{{user?.phone}}</span>
                                    <ng-template #noPhone>
                                        <span>-</span>
                                    </ng-template>
                                </h6>
                                <div class="pt-2 mt-2 border-t border-gray-100">
                                    <div class="flex items-start text-gray-700 mb-2 gap-2"
                                        *ngIf="user?.jobplaces && user?.jobplaces.length > 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2"
                                            strokeLinecap="round" strokeLinejoin="round"
                                            className="w-4 h-4 mr-2 text-blue-500 flex-shrink-0 mt-0.5">
                                            <path
                                                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                                            <circle cx="12" cy="10" r="3" />
                                        </svg>
                                        <div class="flex-1">
                                            <span class="text-xs font-semibold text-gray-600 block mb-1">
                                                {{'company.users.workplaces' | translate}}:
                                            </span>
                                            <div class="flex flex-wrap gap-2">
                                                <span
                                                    *ngFor="let jobPlace of getVisibleJobplaces(user?.jobplaces, user?.id)"
                                                    class="text-xs bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full border border-blue-200 mb-1 pb-0">
                                                    {{jobPlace?.jobPlaceName}}
                                                </span>
                                                <span *ngIf="user?.jobplaces && user?.jobplaces.length > 3"
                                                    class="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full border border-blue-300 font-semibold cursor-pointer hover:bg-blue-200 transition-colors select-none d-flex justify-center items-center"
                                                    (click)="toggleJobplacesExpansion(user?.id)">
                                                    {{getToggleText(user?.jobplaces, user?.id)}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex items-start text-gray-700 mb-2 gap-2"
                                        *ngIf="user?.skills && user?.skills.length > 0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="#a855f7" strokeWidth="2"
                                            strokeLinecap="round" strokeLinejoin="round"
                                            className="w-4 h-4 mr-2 text-purple-500 flex-shrink-0 mt-0.5">
                                            <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                                            <rect width="20" height="14" x="2" y="6" rx="2" />
                                        </svg>
                                        <div class="flex-1">
                                            <span class="text-xs font-semibold text-gray-600 block mb-1">
                                                {{'company.users.skillsRoles' | translate}}:
                                            </span>
                                            <div class="flex flex-wrap gap-2">
                                                <span *ngFor="let skill of user?.skills"
                                                    class="text-xs bg-purple-50 text-purple-700 px-2 py-0.5 rounded-full border border-purple-200 mb-1 pb-0">
                                                    {{ skill | skillDisplayName }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex items-center text-gray-700 gap-2"
                                        *ngIf="user?.employeeRole !== null">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"
                                            strokeLinecap="round" strokeLinejoin="round"
                                            className="w-4 h-4 mr-2 text-green-500 flex-shrink-0">
                                            <path
                                                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                        <span class="text-xs">
                                            <span class="font-semibold text-gray-600"> {{
                                                "company.invite.bookingPricingRights" | translate }}: </span>
                                            <span class="font-medium text-green-600"
                                                *ngIf="user?.employeeRole?.id == 1 || user?.employeeRole?.id == 2">{{
                                                "company.invite.on" | translate }}</span>
                                            <span class="font-medium text-red-600"
                                                *ngIf="user?.employeeRole?.id == 3">{{ "company.invite.off" | translate
                                                }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="members-delete" *ngIf="customer?.employeeRole?.id != 3"
                                (click)="onDeleteUser(user)">
                                <i><img src="../../../assets/svg/trash.svg" alt="Business" loading="lazy" /></i>
                            </div>
                            <div class="members-edit d-none" *ngIf="customer?.employeeRole?.id != 3">
                                <i><mat-icon>edit</mat-icon></i>
                            </div>
                        </div>
                    </div>
                     <!-- Pagination -->
                    <div class="pagination-wrapper" *ngIf="paginate === 1 && totalUsers > 10">
                        <mat-paginator 
                            [length]="totalUsers"
                            [pageSize]="per_page"
                            [pageSizeOptions]="pageSizeOptions"
                            [pageIndex]="page - 1"
                            (page)="onPageChange($event)"
                            aria-label="Select page">
                        </mat-paginator>
                    </div>
                    <div *ngIf="customer?.employeeRole?.id != 3" class="add-member">
                        <button (click)="onInviteCoworkers()" aria-label="Invite New Member">
                            <mat-icon>add</mat-icon>
                            <span>{{'profile.invite-new-member' | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- logout section -->
            <div class="user-info">
                <div class="user-info-head">
                    <h2><span>{{'profile.title' | translate}}</span></h2>
                </div>
                <div class="user-box">
                    <div class="user-key">
                        <button class="logout-btn" (click)="onLogout()" aria-label="Logout">
                            <i><img src="../../../assets/svg/logout.svg" alt="logout" loading="lazy" /> </i>
                            <span>{{'profile.logout' | translate}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Delete user Modal-->
<app-modal *ngIf="this.deleteUserModal" class="overlay">
    <div class="popup-header">
        <div class="row">
            <div class="col-8 text-left">
                <h3 class="modal-title">
                    <img src="../../../assets/svg/trash.svg" alt="Business" loading="lazy" />
                    {{'profile.confirm-delete' | translate}}
                </h3>
            </div>
            <div class="col-4 text-right">
                <span (click)="this.deleteUserModal = false" class="close" style="float: right;">
                    <img src="/assets/img/Close.svg" alt="close" loading="lazy" />
                </span>
            </div>
        </div>
    </div>
    <div class="popup-body">
        <p class="delete-p">{{ 'profile.delete-user-content' | translate }}</p>
    </div>
    <div class="popup-footer">
        <div class="row">
            <div class="col-12 text-right">
                <div class="flexed-buttons">
                    <span class="cancel-btn" (click)="this.deleteUserModal = false">{{'buttons.cancel' |
                        translate}}</span>
                    <input type="button" value="{{'company.users.delete' | translate}}" (click)="onSubmitDelete()"
                        class="save-btn" />
                </div>
            </div>
        </div>
    </div>
</app-modal>